import React from "react";

import Community from "./Community/index"

const list1 = [
  {
    label: "VIEW",
    content: "<a href='javascript:;'>More details</a>"
  },
  {
    label: "Inferred activity ",
    content: "<a href='javascript:;'>More details</a>"
  },
  {
    label: "GENE SYMBOL",
    content:
      "IGNF1 <br> Immunoglobulin-like and fibroconectin type III domain containing 1"
  },
  {
    label: "CLASSIFICATION",
    content: "Uncertain Significance"
  },
  {
    label: "POSITION",
    content: "chr1:201178844 [IGV] [UCS]"
  },
  {
    label: "cytoband",
    content: "q32.1"
  }
];

const list2 = [
  {
    label: "GENE SYMBOL",
    content: "IGNF1"
  },
  {
    label: "position",
    content: "201178844"
  },
  {
    label: "cytoband",
    content: "q32.1"
  },
  {
    label: "translation impact",
    content: "q32.1"
  },
  {
    label: "GENE region",
    content: "Exonic, Intronic"
  },
  {
    label: "GENE region",
    content: "c.1397G>T <br> p.G466V"
  },
  {
    label: "protein variant",
    content: "p.G1402R"
  }
];

class Details extends React.Component {
  renderDetailsItem(x) {
    return (
      <div className="details__item">
        <div className="details__label label">{x.label}</div>
        <div
          className="details__content"
          dangerouslySetInnerHTML={{ __html: x.content }}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="details details_modal">
        <div className="details__body">
          <div className="details__panel">
            <div className="details__row">
              <div className="details__col">
                {this.renderDetailsItem(list1[0])}
                {this.renderDetailsItem(list1[1])}
              </div>
              <div className="details__col">
                {this.renderDetailsItem(list1[3])}
                {this.renderDetailsItem(list1[4])}
                {this.renderDetailsItem(list2[4])}
              </div>
              <div className="details__col">
                {this.renderDetailsItem(list1[2])}
                {this.renderDetailsItem(list2[6])}
              </div>
              <div className="details__col">
                {this.renderDetailsItem(list2[2])}
                {this.renderDetailsItem(list2[3])}
                {this.renderDetailsItem(list2[4])}
              </div>
            </div>
          </div>
          <Community/>
        </div>
      </div>
    );
  }
}

export default Details;
